import cn from "classnames";
import { Datetime } from "components/shared/form";
import { dateTimeToView } from "helpers/date";
import React, { useCallback, useState } from "react";
import { Popover } from "react-tiny-popover";
import { setParcelPlannedDeliveryDate } from "sources/parcel";

export default function PlanDate(props) {
    const [opened, setOpened] = useState(false);
    const [loading, setLoading] = useState(false);
    const [plannedDeliveryDate, setPlannedDeliveryDate] = useState(props.plannedDeliveryDate);

    const handlePopoverToggle = useCallback(() => setOpened((open) => !open), []);

    const handlePopoverClose = useCallback(() => {
        setOpened(false);
    }, []);

    const saveDate = () => {
        setLoading(true);
        setParcelPlannedDeliveryDate({
            id: props.id,
            plannedDeliveryDate,
        }).then((response) => {
            if (response) {
                setOpened(false);
                props.getItem();
            }
            setLoading(false);
        });
    };

    const onClickOutside = useCallback(
        (e) => {
            if (opened && !e.target.closest(".react-datepicker")) {
                handlePopoverClose();
            }
        },
        [opened, handlePopoverClose],
    );

    const popoverContent = (
        <div className={cn("popover font-size-14", { "loading loading--small": loading })}>
            <Datetime
                labelWrapper="col-12 small mb-0"
                wrapper="col-12"
                inPortal
                inputProps={{
                    name: "plannedDeliveryDate",
                }}
                libOptions={{ className: "form-control form-control-xs" }}
                onChange={({ value }) => setPlannedDeliveryDate(value)}
                value={plannedDeliveryDate}
            />
            <div className="d-flex justify-content-between mb-2">
                <div className="btn btn-xs btn-secondary" onClick={handlePopoverClose}>
                    Отмена
                </div>
                <div className="btn btn-xs btn-brand" onClick={saveDate}>
                    Сохранить
                </div>
            </div>
        </div>
    );
    return (
        <Popover
            isOpen={opened}
            content={popoverContent}
            containerStyle={{ zIndex: 130 }}
            onClickOutside={onClickOutside}
        >
            <div className="px-2">
                {props.plannedDeliveryDate ? (
                    <span className="text-muted">
                        Плановая дата доставки {dateTimeToView(props.plannedDeliveryDate)}
                        <span className="link ml-2" onClick={handlePopoverToggle}>
                            Изменить
                        </span>
                    </span>
                ) : (
                    <span className="link" onClick={handlePopoverToggle}>
                        Установить плановую дату доставки
                    </span>
                )}
            </div>
        </Popover>
    );
}
